var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative bg-primary-50 h-screen w-screen dark:bg-gray-900"},[_c('router-view'),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal-container","multiple":""}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"dialog-container","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }